import standardAPI from '@/api/standard_items';

const state = {
  packages: [],
  packages_status: '',
  packages_MetaData: {},
  packages_page: 1,
  packages_perPage: 10,
};

const responseUrl = '/packages';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_packages ({ commit }, getOptions) {
    commit('PACKAGES_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('PACKAGES_SUCCESS', response);
            commit('PACKAGES_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('PACKAGES_READY');
            reject(response);
          } else {
            commit('PACKAGES_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_packages ({ commit, dispatch }, itemData) {
    commit('PACKAGES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          resolve(response);
        } else {
          commit('PACKAGES_READY');
          reject(response);
        }
      });
    });
  },
  edit_packages ({ commit, dispatch }, itemData) {
    commit('PACKAGES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          resolve(response);
        } else {
          commit('PACKAGES_READY');
          reject(response);
        }
      });
    });
  },
  remove_packages ({ commit, dispatch }, itemData) {
    commit('PACKAGES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          resolve(response);
        } else {
          commit('PACKAGES_READY');
          reject(response);
        }
      });
    });
  },
  reorder_packages ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData: orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.packages_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.packages_perPage = max;
  },
  PACKAGES_READY: (state) => {
    state.packages_status = 'ready';
  },
  PACKAGES_REQUEST: (state) => {
    state.packages_status = 'loading';
  },
  PACKAGES_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.packages_MetaData.meta = response.meta;
      state.packages_MetaData.links = response.links;
    }
    state.packages = response.data;
    state.packages_status = 'success';
  },
  PACKAGES_ERROR: (state) => {
    state.packages_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
